import { render, staticRenderFns } from "./ContactCTA.vue?vue&type=template&id=bdd40904&scoped=true&"
import script from "./ContactCTA.vue?vue&type=script&lang=ts&"
export * from "./ContactCTA.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCTA.vue?vue&type=style&index=0&id=bdd40904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd40904",
  null
  
)

export default component.exports